/**
 * The ACRISS size class (position 1) in words — the one map the app has for "MDMR → Mini" (it lived inside
 * `AcrissIcon`'s tooltip; lifted here so Last changes' ACRISS detail can title "MDMR · Mini", CU-869fn0gcp QA 3).
 * Pure, alias-free: node tests import it as is. Unknown or short codes answer null, never "?".
 */
export const ACRISS_CLASS = {
	M: 'Mini', E: 'Economy', C: 'Compact', I: 'Intermediate',
	S: 'Standard', F: 'Fullsize', P: 'Premium', L: 'Luxury',
	U: 'Premium', X: 'Special', O: 'Open',
}

/** `'Mini'` for `'MDMR'`; null when the code is empty or its first letter is not a size class. */
export function acrissClassName(code) {
	if (!code || typeof code !== 'string') return null
	return ACRISS_CLASS[code[0].toUpperCase()] || null
}
